import React, { useState, useEffect } from 'react';
import { translate } from '@utils/i18n';
import WhatsNewModal from '../WhatsNewModal';
import './WhatsNewButtonStyles.scss';
const namespace = 'whats_new_modal';
const WHATS_NEW_CLICKED_KEY = 'whats-new-button-clicked';
export default function WhatsNewButton({ enabled, showTalkToSales = true }) {
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [hasBeenClicked, setHasBeenClicked] = useState(false);
    // Check localStorage on component mount
    useEffect(() => {
        try {
            const clickedStatus = localStorage.getItem(WHATS_NEW_CLICKED_KEY);
            setHasBeenClicked(clickedStatus === 'true');
        }
        catch (error) {
            console.warn("Failed to read What's New button status from localStorage:", error);
        }
    }, []);
    const handleOpenModal = () => {
        // Mark as clicked in localStorage if not already clicked
        if (!hasBeenClicked) {
            try {
                localStorage.setItem(WHATS_NEW_CLICKED_KEY, 'true');
                setHasBeenClicked(true);
            }
            catch (error) {
                console.warn("Failed to save What's New button status to localStorage:", error);
            }
        }
        setIsModalOpen(true);
    };
    const handleCloseModal = () => {
        setIsModalOpen(false);
    };
    if (!enabled) {
        return null;
    }
    return (React.createElement(React.Fragment, null,
        React.createElement("button", { type: "button", className: `whats-new-button ${hasBeenClicked ? 'whats-new-button--clicked' : ''}`, onClick: handleOpenModal, "aria-label": translate('title', { namespace }) },
            React.createElement("span", { className: "whats-new-button__content" },
                React.createElement("span", { className: "whats-new-button__text" }, translate('title', { namespace })),
                React.createElement("i", { className: "fa-light fa-chevron-right whats-new-button__icon", "aria-hidden": "true" }))),
        isModalOpen && (React.createElement(WhatsNewModal, { isOpen: isModalOpen, onClose: handleCloseModal, showTalkToSales: showTalkToSales }))));
}
